/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Liability_S62_Item_2Inputs */

const es_tyc_liability_s62_item_2 = /** @type {(inputs: Tyc_Liability_S62_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fraude o tergiversacion dolosa.`)
};

const en_tyc_liability_s62_item_2 = /** @type {(inputs: Tyc_Liability_S62_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fraud or willful misrepresentation.`)
};

/**
* | output |
* | --- |
* | "Fraud or willful misrepresentation." |
*
* @param {Tyc_Liability_S62_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_liability_s62_item_2 = /** @type {((inputs?: Tyc_Liability_S62_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Liability_S62_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_liability_s62_item_2(inputs)
	return en_tyc_liability_s62_item_2(inputs)
});
export { tyc_liability_s62_item_2 as "tyc.liability.s62_item_2" }